import { useSearchParams } from "react-router-dom";
import clsx from "clsx";

/**
 * Aktuelles category tabs (specification 2.4).
 *
 * Three fixed categories: Informationen / Veranstaltungen / Ereignisse.
 * The selected category is mirrored in the URL `?cat=...` so the choice
 * is sharable and survives a reload.
 */
export const POST_CATEGORIES = [
  { key: "alle",           label: "Alle",           color: "var(--color-primary)"          },
  { key: "information",    label: "Informationen",  color: "var(--color-cat-information)"  },
  { key: "veranstaltung",  label: "Veranstaltungen",color: "var(--color-cat-veranstaltung)"},
  { key: "ereignis",       label: "Ereignisse",     color: "var(--color-cat-ereignis)"     },
] as const;

export type PostCategoryKey = (typeof POST_CATEGORIES)[number]["key"];

export function CategoryTabs() {
  const [params, setParams] = useSearchParams();
  const current = (params.get("cat") ?? "alle") as PostCategoryKey;

  function setCat(next: PostCategoryKey) {
    if (next === "alle") {
      params.delete("cat");
    } else {
      params.set("cat", next);
    }
    setParams(params, { replace: true });
  }

  return (
    <nav
      aria-label="Aktuelles-Kategorie"
      className="flex flex-wrap gap-2 mb-6"
    >
      {POST_CATEGORIES.map((c) => {
        const active = c.key === current;
        return (
          <button
            key={c.key}
            type="button"
            onClick={() => setCat(c.key)}
            className={clsx(
              "px-4 py-2 rounded-md text-sm font-medium border transition-colors",
              active
                ? "border-transparent text-white"
                : "border-border bg-bg text-text hover:bg-bg-muted",
            )}
            style={active ? { background: c.color } : undefined}
            aria-pressed={active}
          >
            <span
              className="inline-block w-2 h-2 rounded-full mr-2 align-middle"
              style={{ background: active ? "#ffffff" : c.color }}
              aria-hidden
            />
            {c.label}
          </button>
        );
      })}
    </nav>
  );
}
